.base {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  border-radius: var(--radius-full);
  font-family: var(--font-body);
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition:
    transform var(--duration-fast) var(--ease-standard),
    box-shadow var(--duration-base) var(--ease-standard),
    background-color var(--duration-base) var(--ease-standard),
    color var(--duration-base) var(--ease-standard),
    border-color var(--duration-base) var(--ease-standard);
  white-space: nowrap;
  user-select: none;
}

.md {
  padding: 12px 20px;
  font-size: var(--text-sm);
  min-height: 44px;
}

.lg {
  padding: 16px 28px;
  font-size: var(--text-base);
  min-height: 52px;
}

.primary {
  background: var(--color-primary);
  color: var(--color-text-inverse);
  box-shadow: var(--shadow-sm);
}

.primary:hover {
  background: var(--color-primary-hover);
  box-shadow: var(--shadow-md);
  transform: translateY(-1px);
}

.primary:active {
  transform: scale(0.98);
}

.secondary {
  background: var(--color-surface);
  color: var(--color-text);
  border: 1px solid var(--color-border);
}

.secondary:hover {
  border-color: var(--color-border-focus);
  color: var(--color-primary);
}

.ghost {
  background: transparent;
  color: var(--color-text);
}

.ghost:hover {
  background: var(--color-surface-alt);
}

.icon {
  display: inline-flex;
  align-items: center;
}
